const ticketdepartment = {
  add: 'ticketdepartment/add',
  getlist: 'ticketdepartment/getlist',
  update: 'ticketdepartment/update',
  remove: 'ticketdepartment/remove',
  get: 'ticketdepartment/get',
  getall: 'ticketdepartment/getall-by-admin',
}
export default ticketdepartment
